export const getInterestsForView = (interests: string[] | undefined) => {
  if (!interests || interests.length === 0) {
    return {
      toDisplay: [],
      notDisplayed: [],
    };
  }

  return {
    toDisplay: interests.slice(0, 2),
    notDisplayed: interests.slice(2),
  };
};
